/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentRunReportDetailQuerySection extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentRunReportDetailQuerySection");
    }

    getFixupPrototypeFunction() { return AssessmentRunReportDetailQuerySection.fixupPrototype; }

    static newInstance(model: Partial<AssessmentRunReportDetailQuerySection>): AssessmentRunReportDetailQuerySection {
        let obj = Object.assign(new AssessmentRunReportDetailQuerySection(), model);
        AssessmentRunReportDetailQuerySection.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentRunReportDetailQuerySection>): AssessmentRunReportDetailQuerySection {
        if (!model) return null;
        return AssessmentRunReportDetailQuerySection.newInstance(<AssessmentRunReportDetailQuerySection> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentRunReportDetailQuerySection) {
        if (!obj) return;

        models.AssessmentRunReportDetailQuerySection.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentRunReportDetailQuerySection): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentRunReportDetailQuerySection.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Section of workload assessment detailed report
     */
    sections: Array<models.AssessmentRunReportDetailSection>;

}
